import { Map } from 'immutable'
import { SET_RESOLVER_LOCATION } from '../resolver/actions'
import {
  createRelative,
  isFullPlayer,
  isCart,
  isVideoOrSeries,
} from '../url/index'
import { setCommentsVisible } from '../comments/actions'
import { selectIsCommentsVisible } from '../comments/selectors'
import { clearUpstreamContext } from '../upstream-context/actions'
import { URL_HOME, URL_SEARCH } from '../url/constants'

export function pageUnmount ({ after }) {
  return after(SET_RESOLVER_LOCATION, async ({ dispatch }) => {
    dispatch(setCommentsVisible(false))
  }).when(({ state }) => {
    return selectIsCommentsVisible(state)
  })
}

export function watchClearUpstreamContext ({ after }) {
  return after(SET_RESOLVER_LOCATION, async ({ dispatch }) => {
    dispatch(clearUpstreamContext())
  }).when(({ state, prevState }) => {
    const { upstreamContext, resolver } = state
    const { resolver: prevResolver } = prevState

    const path = resolver.get('path') || ''
    const location = resolver.get('location')
    const prevPath = prevResolver.get('path') || ''
    const prevUtmSource = prevResolver.getIn(['query', 'utm_source'])
    const mhTileData = upstreamContext.getIn(['data', 'mhTileData'])
    const playEventData = upstreamContext.getIn(['data', 'playEventData'])
    const sharePageAttribution = upstreamContext.getIn(['data', 'sharePageAttribution'])

    const hasMhTileData = Map.isMap(mhTileData) && mhTileData.size > 0
    const hasPlayEventData = Map.isMap(playEventData) && playEventData.size > 0
    const hasCheckoutEventsData = Map.isMap(sharePageAttribution) && sharePageAttribution.size > 0

    const prevDetailPage = isVideoOrSeries(prevPath)
    const prevHomePage = createRelative(prevPath) === createRelative(URL_HOME)
    const prevSearchPage = createRelative(prevPath) === createRelative(URL_SEARCH)
    const prevPage = prevHomePage || prevSearchPage
    const prevSharePage = prevUtmSource === 'share' && hasCheckoutEventsData
    const isDetailPage = isVideoOrSeries(path) && hasMhTileData
    const isPlayer = isFullPlayer(location.query || {}) && hasPlayEventData
    const isCheckout = isCart(path) && hasCheckoutEventsData

    // Don't clear upstream context if we are on the checkout flow
    // and we started in the share page
    if (isCheckout || prevSharePage) {
      return false
    }

    // Don't clear upstream context if we are redirecting to the VideoPlayer
    // or to a DetailPage from the MemberHome or Search page
    if ((prevPage && isPlayer)
      || (prevPage && isDetailPage)
      || (prevDetailPage && isPlayer)) {
      return false
    }

    return true
  })
}
